import { contactsPresentationApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CONTACTS_PRESENTATION_ACTION_TYPE = createNamedActions('contactsPresentation', {
  GET_CONTACTS: 'GET_CONTACTS',
  UPDATE_CONTACTS: 'UPDATE_CONTACTS',
});

export const getContactsPresentationAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await contactsPresentationApi.getContactsPresentation(params);

  return dispatch({
    type: CONTACTS_PRESENTATION_ACTION_TYPE.GET_CONTACTS,
    payload: data.ContactsPresentations,
  });
});

export const updateContactsPresentationAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await contactsPresentationApi.updateContactsPresentation(params);

  return dispatch({
    type: CONTACTS_PRESENTATION_ACTION_TYPE.UPDATE_CONTACTS,
    payload: data.ContactsPresentations,
  });
});
